// "Pick a spot anywhere on the page" (Phelipe 2026-10-19): when the dot is
// dropped away from a heading, a button, a table or a field, the place is the
// block under it — any visible box on the page — before or after it. The
// block is remembered by a short path from the page's main area plus its
// first words; on a later load the path is tried first, then the words, so
// a small change to the page still finds it (page_blocks / custom_fields
// place it; "lost its place" covers the rest).

const norm = (s) => (s || "").replace(/\s+/g, " ").trim().toLowerCase()
const BLOCK = /^(div|section|article|aside|header|footer|form|fieldset|table|ul|ol|nav|p|h1|h2|h3|h4|li|figure|details|turbo-frame)$/i
const OURS = "#studio-bubble, #instant-feedback, #feedback-detail, [data-studio-spot-picker], [data-page-block], [data-studio-ghost], [data-custom-field], [data-page-blocks-target='holder'], [data-custom-fields-target='holder']"

// A selector like "div:nth-child(2)>section:nth-child(1)>div:nth-child(3)", from `root` down to `el`.
export function elementPath(el, root) {
  const parts = []
  for (let n = el; n && n !== root && n.parentElement; n = n.parentElement) {
    const tag = n.tagName.toLowerCase()
    const idx = [...n.parentElement.children].filter((c) => c.tagName === n.tagName).indexOf(n) + 1
    parts.unshift(`${tag}:nth-of-type(${idx})`)
    if (parts.length > 14) break
  }
  return parts.join(">")
}

export function blockWords(el) {
  return (el?.innerText || el?.textContent || "").replace(/\s+/g, " ").trim().slice(0, 80)
}

// The block under a point: the first visible box at least 120×18 that isn't ours, up to `root`.
export function blockAt(x, y, root, skip = []) {
  const under = document.elementsFromPoint(x, y).find((n) => !skip.includes(n) && !skip.some((s) => s.contains(n)) && root.contains(n) && n !== root && !n.closest(OURS))
  if (!under) return null
  // Inside a table, the place is the whole table: nothing can sit between its rows or cells.
  const table = under.closest("table")
  if (table && root.contains(table) && table !== root) return table
  for (let n = under; n && n !== root; n = n.parentElement) {
    const r = n.getBoundingClientRect()
    const block = BLOCK.test(n.tagName) || getComputedStyle(n).display !== "inline"
    if (block && r.width >= 120 && r.height >= 18) return n
  }
  return null
}

// Finds a remembered block: by its path when the words still match (or the path is all we have), else by its words.
export function findElementLandmark(lm, root) {
  if (!lm || !root) return null
  const want = norm(lm.text)
  let el = null
  if (lm.path) { try { el = root.querySelector(lm.path) } catch (e) { el = null } }
  if (el && (!want || norm(blockWords(el)).startsWith(want.slice(0, 40)) || norm(blockWords(el)).includes(want))) return el
  if (!want) return el
  const all = [...root.querySelectorAll("div, section, article, p, li, table, form, fieldset, h1, h2, h3, h4")].filter((n) => !n.closest(OURS) && n.getClientRects().length)
  const hits = all.filter((n) => norm(blockWords(n)).startsWith(want.slice(0, 40)))
  // The smallest box whose words start the same way: the block itself, not its ancestors.
  hits.sort((a, b) => (a.getBoundingClientRect().width * a.getBoundingClientRect().height) - (b.getBoundingClientRect().width * b.getBoundingClientRect().height))
  return hits[+lm.index || 0] || hits[0] || el
}
